const trigger = () => {
  const submenus = document.querySelectorAll('.c-mobile-menu--has-submenu');

  if (submenus) {
    submenus.forEach(submenu => {
      const btn = submenu.querySelector('.c-mobile-menu__sublink-trigger');
      const dropdown = submenu.querySelector('.c-mobile-menu__dropdown');
      const back = submenu.querySelector(
        '.c-mobile-menu__sublabel.c-mobile-menu__sublabel--back',
      );

      if (btn && dropdown) {
        btn.addEventListener('click', () => {
          dropdown.classList.add('c-mobile-menu__dropdown--active');
        });
      }

      if (back && dropdown) {
        back.addEventListener('click', () => {
          dropdown.classList.remove('c-mobile-menu__dropdown--active');
        });
      }
    });
  }
};

trigger();
